export const MEETINGS_PILL_NEW_LOZENGE_FIRST_SEEN_AT_KEY = 'meetings-pill-new-lozenge:firstSeenAt';
export const MEETINGS_PILL_NEW_LOZENGE_CLICK_COUNT_KEY = 'meetings-pill-new-lozenge:clickCount';

export const MeetingsPillNewLozengeOnboardingKeys: readonly [
	'meetings-pill-new-lozenge:firstSeenAt',
	'meetings-pill-new-lozenge:clickCount',
] = [
	MEETINGS_PILL_NEW_LOZENGE_FIRST_SEEN_AT_KEY,
	MEETINGS_PILL_NEW_LOZENGE_CLICK_COUNT_KEY,
] as const;
